module.exports = __webpack_public_path__ + "img/user.7a121b9e.png";